export default __webpack_public_path__ + "static/es-OlderAdults-46adeb95e6bb117a85464dd4bec44d2a.pdf";